import React, { memo } from 'react';

import { Box, Button, Skeleton } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';

import { IconDirection } from 'constants/coreDesignSystem';

import MobileLoanActionsDrawer from '../MobileLoanActionsDrawer';

import { useLoanActionsControlsContext } from './hooks';
import { mobileLoanActionsButtonStyles } from './LoanActionsControlsTopLevelSlot.styles';
import { LoanActionsControlsTopLevelSlotTestIds } from './LoanActionsControlsTopLevelSlot.testIds';
import { renderTopLevelAction } from './LoanActionsControlsTopLevelSlot.utils';

const LoanActionsControlsTopLevelSlot = () => {
  const {
    isDataLoaded,
    isMobile,
    isMobileDrawerOpen,
    onOpenMobileDrawer,
    onCloseMobileDrawer,
    groupedActions,
    executingActionId,
    disabledLoanActionsSet,
    runningLoanActionsSet,
    onConfirmLoanAction,
    onLoanActionClick,
  } = useLoanActionsControlsContext();

  if (!isDataLoaded) {
    return (
      <Box className="flex gap-8">
        <Skeleton className="rounded-4" height={28} variant="rectangular" width={120} />
        <Skeleton className="rounded-4" height={28} variant="rectangular" width={120} />
      </Box>
    );
  }

  if (isMobile) {
    return (
      <>
        <Button
          aria-selected={isMobileDrawerOpen}
          data-testid={LoanActionsControlsTopLevelSlotTestIds.MOBILE_LOAN_ACTIONS_BUTTON}
          endIcon={<ArrowCheckIcon direction={IconDirection.DOWN} />}
          sx={mobileLoanActionsButtonStyles}
          variant="outlined"
          onClick={onOpenMobileDrawer}
        >
          Loan Actions
        </Button>
        <MobileLoanActionsDrawer
          disabledLoanActionsSet={disabledLoanActionsSet}
          executingActionId={executingActionId}
          groupedActions={groupedActions}
          open={isMobileDrawerOpen}
          onClose={onCloseMobileDrawer}
          onExecuteAction={onLoanActionClick}
        />
      </>
    );
  }

  return (
    <>
      {groupedActions.topLevel.map(actionData =>
        renderTopLevelAction({
          actionData,
          executingActionId,
          disabledLoanActionsSet,
          runningLoanActionsSet,
          onConfirmLoanAction,
          onLoanActionClick,
        }),
      )}
    </>
  );
};

export default memo(LoanActionsControlsTopLevelSlot);
